<template>
  <div>
    <v-app-bar dense light color="grey lighten-4" flat tile  >
      <v-app-bar-nav-icon></v-app-bar-nav-icon>
      <v-toolbar-title>工作空间</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>mdi-heart</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>mdi-magnify</v-icon>
      </v-btn>

      <v-menu left bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item v-for="n in 5" :key="n" @click="() => {}">
            <v-list-item-title>Option {{ n }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-row class="mb-12">
      <v-col sm="12" md="12">
        <searchBar></searchBar>
      </v-col>
    </v-row>
    <v-row class="mb-6">
      <v-col sm="5" md="6">
        <MonthlyStats></MonthlyStats>
      </v-col>
      <v-col sm="5" md="6">
        <ApplyTrend2></ApplyTrend2>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="6" md="5" lg="6">     <ApplyTrend></ApplyTrend></v-col>
      <v-col sm="6" md="5" offset-md="2" lg="6" offset-lg="0">
        <ProvinceChart></ProvinceChart>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import ApplyTrend from "@/components/widgets/applyTrend.vue";
import ApplyTrend2 from "@/components/widgets/applyTrend2.vue";
import searchBar from "@/components/widgets/searchBar.vue";
import ProvinceChart from "@/components/widgets/ProvinceChart.vue";
import MonthlyStats from "@/components/widgets/monthlyStats.vue";
//import { ItemLink, ItemSm, ItemMd, ItemLg } from 'vue-muuri';

export default {
  name: "index",
  components: {
    searchBar,
    ApplyTrend,
    ApplyTrend2,
    ProvinceChart,
    MonthlyStats,
    // ItemMd,ItemLg,ItemSm,ItemLink
  },
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
</style>
